import * as React from 'react';
import { SummaryData, TimeType, timeTypesConfigMap } from './common';
import NumberInput from '../../common/inputs/NumberInput';
import { IFormInputComponent } from '../../common/interfaces/IFormInputComponent';
import { Validator } from '../../../validation';
import { css } from 'office-ui-fabric-react';

type Props = {
    timeType: TimeType,
    summaryData: SummaryData
    onEditComplete: (effort: number | null, completedWork: number, remainingWork: number | null) => void,
}
const EditMode = (props: Props) => {
    const { summaryData, timeType, onEditComplete } = props;

    const value = timeType === 'Effort'
        ? summaryData.effort
        : timeType === 'CompletedWork'
            ? summaryData.completedWork
            : undefined;

    return <div aria-hidden onClick={(e) => { e.stopPropagation(); }} className={css('value-wrap', timeTypesConfigMap[timeType].className)}>
        <div className="value">
            <NumberInput
                inputRef={(_: IFormInputComponent | null) => _?.focus()}
                validator={Validator.new().required().decimal().min(0).build()}
                selectOnFocus
                value={value ?? 0}
                resetInvalidOnBlur
                onEditComplete={(_: number | null) => {
                   if (_ == null) {
                        onEditComplete(null, 0, null);
                        return;
                    }

                    const newSummaryData: SummaryData = { ...summaryData };
                    if (timeType === 'Effort') {
                        newSummaryData.effort = _;
                    } else if (timeType === 'CompletedWork') {
                        newSummaryData.completedWork = _;
                    }

                    onEditComplete(newSummaryData.effort, newSummaryData.completedWork, newSummaryData.remainingWork);
                }} />
        </div>
        <div className="unit">hours</div>
    </div>;
}

export default EditMode;
